import PageProduct from '@/components/PageProduct';

export default PageProduct;

export async function getStaticProps() {
  return {
    props: {
      path: '/eurojackpot',
      theme: 'eurojackpot',
      description:
        'Eurojackpot auf einen Blick ✓: Online-Spielschein, aktuelle Gewinnzahlen inkl. Ziehungsvideo und eine kurze Spielanleitung',
      title: 'Eurojackpot | Eurolotto ► Lotterie-Übersicht | LOTTO.de',
      contents: {
        name: 'contents',
        nodes: [
          {
            template: 'lotto:components/pageHeading',
            value: 'Eurojackpot',
          },
          {
            template: 'lotto:components/section',
            link: {
              path: '/eurojackpot/zahlen',
            },
            title: 'Die aktuellen Gewinnzahlen',
            linkLabel: 'Alle Gewinnzahlen & Quoten',
            contents: {
              name: 'contents',
              nodes: [
                {
                  variant: 'eurojackpot',
                  template: 'lotto:components/winningNumbers',
                },
                {
                  variant: 'eurojackpot',
                  template: 'lotto:components/drawVideo',
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            title: 'Eurojackpot auf einen Blick – Fakten zum Eurolotto',
            contents: {
              name: 'contents',
              nodes: [
                {
                  template: 'lotto:components/iconList',
                  contents: {
                    name: 'contents',
                    nodes: [
                      {
                        text: '2,00 € je Spielfeld zuzüglich Bearbeitungsgebühren je Spielschein',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-money',
                        title: 'Spieleinsatz',
                      },
                      {
                        text: 'Den Jackpot gewinnen Sie mit einer Chance von 1 zu 139.838.160',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-draw',
                        title: 'Gewinnwahrschein­lichkeit',
                      },
                      {
                        text: 'Jeden Dienstag- und Freitagabend werden in Helsinki die Eurojackpot-Zahlen gezogen',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-tv',
                        title: 'Ziehung',
                      },
                      {
                        text: 'Sie können 1, 2, 3, 4 oder 5 Wochen bei Eurojackpot mitspielen',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-calendar',
                        title: 'Spielschein-Laufzeit',
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            title: 'So funktioniert Eurojackpot',
            contents: {
              name: 'contents',
              nodes: [
                {
                  template: 'lotto:components/cardSlider',
                  contents: {
                    name: 'contents',
                    nodes: [
                      {
                        text: '<p>Auf einem <a href="/eurojackpot/spielen">Eurojackpot-Spielschein</a> befinden sich - je nach ausgewähltem Bundesland - 8 bis maximal 15 Tippfelder mit jeweils 50 Zahlen und 12 Eurozahlen. In einem Tippfeld müssen Sie jeweils 5 aus 50 Zahlen und 2 aus 12 Eurozahlen ankreuzen. Sie können ein Feld anklicken und die Zahlen selbst ankreuzen oder Sie nutzen bequem unsere Quick-Tipps: damit können Sie ein oder mehrere Tippfelder schnell und bequem per Zufall ausfüllen.</p>\n',
                        template: 'lotto:components/cardSliderItem',
                        labelNext: 'Nächster Schritt',
                        title: '1. Eurojackpot-Zahlen tippen',
                        labelPrev: 'Vorheriger Schritt',
                      },
                      {
                        text: '<p>Die Losnummer können Sie einfach per Eingabe von Nummern ändern oder per Zufall eine neue Nummer generieren. Sie möchten auch an den <a href="/lotto-6aus49/spiel77-super6/spielregeln">Zusatzlotterien Spiel 77 oder SUPER 6</a> teilnehmen? Mit den Endziffern der Losnummer definieren Sie auch die Nummern für die Zusatzlotterien. Zusätzlich können Sie die Anzahl der Wochen für die Teilnahme an den <a href="/eurojackpot/ziehung">Eurojackpot-Ziehungen</a> auswählen.</p>\n',
                        template: 'lotto:components/cardSliderItem',
                        labelNext: 'Nächster Schritt',
                        labelPrev: 'Vorheriger Schritt',
                        title: '2. Losnummer und Zusatzlotterien wählen',
                      },
                      {
                        text: '<p>Ihren Eurojackpot-Spieltipp für die Abgabe bei Ihrer Landeslotteriegesellschaft fassen wir noch einmal in einer Übersicht mit allen relevanten Angaben zusammen. In diesem Schritt können Sie auch die Laufzeit Ihres Spielscheins zwischen einer und fünf Wochen festlegen. </p>\n',
                        template: 'lotto:components/cardSliderItem',
                        labelNext: 'Nächster Schritt',
                        title: '3. Übersicht Ihres Spieltipps',
                        labelPrev: 'Vorheriger Schritt',
                      },
                      {
                        text: '<p>Ihren <a href="/eurojackpot/spielen">Eurojackpot-Spielschein</a> können Sie bei der Landeslotteriegesellschaft Ihres Bundeslandes abgeben. Falls Sie dort bereits registrierter Nutzer sind, können Sie sich einfach anmelden und den Spielschein abgeben. Falls Sie noch kein Kunde einer Landeslotteriegesellschaft sind, müssen Sie erst den Registrierungsprozess in Ihrem Bundesland abschließen.</p>\n',
                        template: 'lotto:components/cardSliderItem',
                        labelNext: 'Nächster Schritt',
                        title: '4. Anmelden oder registrieren',
                        labelPrev: 'Vorheriger Schritt',
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            title: 'Neuigkeiten von Eurojackpot',
            contents: {
              name: 'contents',
              nodes: [
                {
                  category: 'eurojackpot',
                  template: 'lotto:components/newsTeaser',
                  amount: 2,
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            title: 'Sicherheit bei LOTTO.de',
            hideLine: true,
            contents: {
              name: 'contents',
              nodes: [
                {
                  template: 'lotto:components/iconList',
                  contents: {
                    name: 'contents',
                    nodes: [
                      {
                        text: 'Wir leiten Ihren Spielschein-Tipp mit einer sicheren Verbindung an die Landes­lotterie­gesellschaft Ihres Bundeslandes weiter - dort können Sie online spielen.',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-shield',
                        title: 'Sicher & legal',
                      },
                      {
                        text: 'Rechtliche Grundlage für erlaubtes Glücksspiel in Deutschland sind der Glücksspiel­staatsvertrag und die Glücksspiel­gesetze der Länder.',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-court',
                        title: 'Staatlich erlaubt',
                      },
                      {
                        text: 'Im Gewinnfall haben Sie bei staatlich erlaubten Lotterien einen Rechtsanspruch auf eine garantierte Auszahlung durch die Landes­lotterie­gesellschaften.',
                        template: 'lotto:components/iconListItem',
                        icon: 'icon-big-payoff',
                        title: 'Garantierte Auszahlung',
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            template: 'lotto:components/section',
            hideLine: true,
            contents: {
              name: 'contents',
              nodes: [
                {
                  game: '1',
                  template: 'lotto:components/linkGame',
                },
              ],
            },
          },
        ],
      },
    },
  };
}
